export enum LocalStorageKeys {
    PERMISSIONS = 'edl_permissions',
    ROLES_I_CAN_MANAGE = 'edl_roles_i_can_manage',
    ROLES_I_CAN_MANAGE_PER_BUILDING = 'edl_roles_i_can_manage_per_building',
}